<script setup lang="ts">
import ESACWizard from './components/wizard/ESACWizard.vue'
import { isUserLoggedIn } from './utilities/api'
import { getPlatformSettings } from './utilities/usePlatformSettings'
import { provide, ref } from 'vue'

const wizardActivated = getPlatformSettings().compliance_profile === 'esac'
const userIsLoggedIn = isUserLoggedIn()
const wizardClosed = ref(false)
function closeWizard() {
    wizardClosed.value = true
    window.location.reload()
}
provide('closeWizard', closeWizard)
</script>

<template>
    <ESACWizard v-if="wizardActivated && userIsLoggedIn && !wizardClosed" />
</template>
